import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PolicyPage.css';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    return (
        <div className="policy-page">
            <button className="policy-back-btn" onClick={() => navigate(-1)}>
                ← Back
            </button>

            <div className="policy-container">
                <h1>Privacy &amp; Cookie Policy</h1>
                <p className="policy-meta">Last updated: June 2025 &nbsp;·&nbsp; VerDict AI</p>

                <h2>1. Overview</h2>
                <p>
                    VerDict AI (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) is a prototype AI-powered fact-checking service.
                    This policy explains what personal data we collect, why we collect it, and how we use it.
                    By using the service you agree to the practices described here.
                </p>

                <h2>2. Data We Collect</h2>
                <p>When you register and use VerDict AI we may collect:</p>
                <ul>
                    <li><strong>Name and email address</strong> — provided by you at registration, used to identify your session and communicate with you.</li>
                    <li><strong>Queries you submit</strong> — the text, links, or images you submit for fact-checking, stored to power your search history and to improve the service.</li>
                    <li><strong>Usage data</strong> — page visits, feature interactions, and query counts, collected to understand how the product is used.</li>
                    <li><strong>Technical data</strong> — browser type, IP address, and approximate location, collected automatically for security and analytics purposes.</li>
                </ul>

                <h2>3. How We Use Your Data</h2>
                <ul>
                    <li>To operate and deliver the fact-checking service.</li>
                    <li>To maintain your query history and session state.</li>
                    <li>To improve accuracy, performance, and features of the prototype.</li>
                    <li>To detect and prevent abuse or malicious use.</li>
                    <li>To contact you with product updates if you have opted in.</li>
                </ul>

                <h2>4. Data Sharing</h2>
                <p>
                    We do not sell your personal data. We may share data with:
                </p>
                <ul>
                    <li><strong>AI model providers</strong> (e.g. Google Gemini, OpenAI, Anthropic) — your query content is sent to these APIs to generate fact-check results. Their own privacy policies apply.</li>
                    <li><strong>Infrastructure providers</strong> (AWS) — hosting, storage, and logging.</li>
                    <li><strong>Law enforcement</strong> — only where required by applicable law.</li>
                </ul>

                <h2>5. Cookies &amp; Local Storage</h2>
                <p>We use the following:</p>
                <ul>
                    <li><strong>Session cookies</strong> — to keep you logged in during your visit. These expire when you close your browser or log out.</li>
                    <li><strong>Local storage</strong> — to cache your authentication token client-side for a smoother experience.</li>
                </ul>
                <p>We do not use third-party advertising or tracking cookies.</p>

                <h2>6. Data Retention</h2>
                <p>
                    We retain your account data and query history for as long as your account is active or as needed to operate the prototype.
                    As this is a prototype application, data may be reset periodically without notice.
                    You can request deletion of your data by contacting us.
                </p>

                <h2>7. Your Rights</h2>
                <p>Depending on your jurisdiction you may have rights to:</p>
                <ul>
                    <li>Access the personal data we hold about you.</li>
                    <li>Request correction of inaccurate data.</li>
                    <li>Request deletion of your data.</li>
                    <li>Object to or restrict certain processing.</li>
                </ul>
                <p>To exercise any of these rights, contact us at the address below.</p>

                <h2>8. Security</h2>
                <p>
                    We implement reasonable technical and organisational measures to protect your data, including
                    encrypted connections (TLS), hashed credentials, and access controls.
                    No system is completely secure; use of the service is at your own risk.
                </p>

                <h2>9. Children</h2>
                <p>
                    VerDict AI is not directed at children under 13. We do not knowingly collect personal data
                    from children. If you believe a child has provided us with their data, please contact us.
                </p>

                <h2>10. Changes to This Policy</h2>
                <p>
                    We may update this policy as the service evolves. The &quot;Last updated&quot; date at the top will
                    reflect any changes. Continued use of the service after changes constitutes acceptance.
                </p>

                <h2>11. Contact</h2>
                <p>
                    Questions about this policy? Reach us at{' '}
                    <a href="mailto:contact@nerdailytics.com">contact@nerdailytics.com</a>.
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
